import { appModulesToRequiredUserRoles } from "@jugl-web/domain-resources/common/consts";
import { PageNavParams } from "@web-src/modules/navigation/types";
import { ModulePagesConfig } from "@web-src/modules/navigation/types/ModulePagesConfigs";
import {
  SubscriptionPlanModuleId,
  CRMChannel,
  UserRole,
} from "@jugl-web/rest-api";
import { ClientSupportPage } from "./ClientSupportPage";

export type ClientSupportPagesNavigationParams = {
  clientSupport: PageNavParams<never, { code?: string }>;
  clientSupportChannel: PageNavParams<{
    channel: CRMChannel;
  }>;
  clientSupportActiveConversation: PageNavParams<{
    channel: CRMChannel;
    activeConversation: string;
  }>;
};

export const clientSupportPagesNavigationConfig: ModulePagesConfig<ClientSupportPagesNavigationParams> =
  {
    clientSupport: {
      element: <ClientSupportPage />,
      path: "client-support",
      isPrivate: true,
      requiredCXUserRoles: [UserRole.admin, UserRole.member],
      requiredUserRoles: appModulesToRequiredUserRoles.clientSupport,
      requiredModules: [SubscriptionPlanModuleId.whatsappCrm],
    },
    clientSupportChannel: {
      element: <ClientSupportPage />,
      path: "client-support/:channel",
      isPrivate: true,
      requiredCXUserRoles: [UserRole.admin, UserRole.member],
      requiredUserRoles: appModulesToRequiredUserRoles.clientSupport,
      requiredModules: [SubscriptionPlanModuleId.whatsappCrm],
    },
    clientSupportActiveConversation: {
      element: <ClientSupportPage />,
      path: "client-support/:channel/:activeConversation",
      isPrivate: true,
      requiredCXUserRoles: [UserRole.admin, UserRole.member],
      requiredUserRoles: appModulesToRequiredUserRoles.clientSupport,
      requiredModules: [SubscriptionPlanModuleId.whatsappCrm],
    },
  };
